import { render } from "./Disciples2Page.vue?vue&type=template&id=a22d8896"
import script from "./Disciples2Page.vue?vue&type=script&lang=js"
export * from "./Disciples2Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__